import React, { useState, useRef, useEffect } from 'react';
import { FaEllipsisV } from 'react-icons/fa';

const ActionDropdown = ({ actions = [] }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className="p-2 rounded-full hover:bg-gray-200 transition text-gray-500"
        aria-label="Options"
      >
        <FaEllipsisV size={18} />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-50">
          <div className="py-1">
            {actions.map((action, index) => {
              if (action.isSeparator) {
                return <div key={index} className="border-t my-1 mx-2" />;
              }
              if (action.custom) {
                return <div key={index} className="px-2 py-2">{action.custom}</div>;
              }
              return (
                <button
                  key={index}
                  type="button"
                  className={`w-full flex items-center gap-2 px-4 py-2 text-sm text-left ${action.color || 'text-gray-700'} hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed`}
                  onClick={() => {
                    action?.onClick?.();
                    setOpen(false);
                  }}
                  disabled={action.disabled}
                >
                  {action.icon && <span className="flex-shrink-0">{action.icon}</span>}
                  <span>{action.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
